import React from 'react';

const AIContext = React.createContext('aiContext');

export const AIContextProvider = AIContext.Provider;

export default AIContext;
